




















































































































































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { IGuest } from "@/@types/admin/guest/user";
import { auth, cruiseOffers } from "@/config/host.config";
import { deleteElement } from "@/api/delite/delite-element";
import { IRoom, IRoomControl } from "@/@types/hotel/room";
import { IVirtualRooma } from "@/@types/hotel/virtual_rooms";
import { AxiosError, AxiosResponse } from "axios";
import { IUser } from "@/@types/admin/user/user";
import { ICruise } from "@/@types/cruiseOffers/cruiseList";

import GuestRegistrationHeader from "@/components/tables/administration/guests/guest-registration-header.vue";
import GuestRegistrationFooter from "@/components/tables/administration/guests/guest-registration-footer.vue";
import GuestSortsSlidebar from "@/components/tables/administration/guests/guest-sorts-slidebar.vue";
import GuestList from "@/components/tables/administration/guests/guest-list.vue";
import AddGuestForm from "@/components/forms/users/guest/add-guest-form.vue";
import RootVroms from "@/components/tables/administration/guests/root-vroms.vue";
import GuestSorts from "@/components/tables/administration/guests/guest-sorts";
import Guests from "@/components/tables/administration/guests/guests";
import Bitrix from "@/components/tables/administration/guests/bitrix.vue";
import GuestParams from "@/components/tables/administration/guests/guest-params";

@Component({
  components: {
    "g-header": GuestRegistrationHeader,
    "g-footer": GuestRegistrationFooter,
    "guest-form": AddGuestForm,
    GuestList,
    sorts: GuestSortsSlidebar,
    RootVroms,
    Guests,
    Bitrix,
  },
})
export default class GuestRegistration extends Mixins(
  GuestSorts,
  Guests,
  GuestParams
) {
  @Prop({ type: Array, default: () => [] }) managers!: Array<IUser>;
  @Prop({ type: Array, default: () => [] }) routes!: Array<string>;
  @Prop({ type: String, default: "" }) route!: string;
  spinner = false;
  check = false;

  shipCode = this.$store.getters.getHotelID;
  wievs = ["list", "plan"];
  wiev = "";
  manager_id = "";
  search = "";

  date = new Date();

  rooms: Array<IRoom> = [];
  roomTypes: Array<IRoomControl> = [];
  roomLevels: Array<IRoomControl> = [];
  roomStatuses: Array<IRoomControl> = [];
  cruises: Array<ICruise> = [];

  restore = false;
  change_id = "";
  room_id = "";

  vroomInterval: ReturnType<typeof setInterval> | undefined;

  get manager(): IUser | null {
    const waiter = this.managers.find((w) => w._id === this.manager_id);
    return waiter ? waiter : null;
  }

  get hasActiveSorts(): boolean {
    return !!(
      this.children ||
      this.pensioners ||
      this.birthday ||
      this.cruise_code ||
      this.gender ||
      this.doc_type ||
      this.citizenship ||
      this.room_type ||
      this.room_level
    );
  }

  get guest(): IGuest | null {
    const fullList = this.guestList;
    const guest = fullList.find((el) => el._id == this.change_id);
    if (Array.isArray(guest)) return null;
    return guest ? guest : null;
  }

  async dropGuests(): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("virtual-rooms.buttons.drop.guests")),
        }
      );

      if (result === true) {
        const ids: Array<string> = [];
        this.guests.forEach((el) => ids.push(el._id));
        this.deleteGuests(ids);
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  async dropNewGuests(): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("virtual-rooms.buttons.drop.new")),
        }
      );

      if (result === true) {
        const ids: Array<string> = [];
        this.newGuests.forEach((el) => ids.push(el._id));
        this.dropNotRegsGuests(ids);
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  async dropNotRegsGuests(ids: string[]): Promise<void> {
    const uri = auth.guest.many_new;
    try {
      const res = await this.$axios.put(uri, ids);
      if (res.status === 200) {
        this.getCruiseList();
        this.isSuccess("error.200");
      }
    } catch (error: AxiosError | unknown) {
      console.log(error);
      this.isError(error);
    }
  }

  async addMany(list: IGuest[]): Promise<void> {
    if (this.newGuests.length) {
      try {
        const result = await this.$bvModal.msgBoxConfirm(
          String(this.$i18n.t("virtual-rooms.errors.add-new-guests.text")),
          {
            title: String(
              this.$i18n.t("virtual-rooms.errors.add-new-guests.title")
            ),
          }
        );

        if (result !== true) return;
      } catch {
        return;
      }
    }
    this.addNewGuestMany(list);
  }

  newRreservation(): void {
    console.log("newRreservation");
  }

  mustChangeGuest(id: string): void {
    this.change_id = id;
    this.$nextTick(() => this.$bvModal.show("guest-changer"));
  }

  restoringInternetAccessAll(): void {
    const ids: string[] = [];
    this.guestList.forEach((g) => ids.push(g._id));
    this.restoringInternetAccess(ids);
  }

  async restoringInternetAccess(guestIds: string[]): Promise<void> {
    const uri = auth.internet.restoring_internet_access;
    try {
      const res = await this.$axios.post(uri, { guestIds });
      if (res.status === 200) {
        this.isSuccess("error.200");
      }
    } catch (error: AxiosError | unknown) {
      console.log(error);
      this.isError(error);
    }
  }

  async resettle(ids: string[], room: string): Promise<void> {
    if (!ids.length || !room) return;
    this.$bvModal.hide("guest-room-resettle");

    const target = this.rooms.find((r) => r._id == room);
    const roomNumber = target ? target.name : "";

    this.spinner = true;
    try {
      for (const id of ids) {
        const guest = this.guestList.find((g) => g._id == id);
        if (!guest) continue;

        const old_room =
          guest.stay_data && guest.stay_data.room
            ? guest.stay_data.room.id
            : "";

        const data = {
          personal_data: guest.personal_data,
          additional_data: guest.additional_data,
          comment: guest.comment,
          stay_data: {
            ...(guest.stay_data || {}),
            room: { id: room, number: roomNumber },
          },
        };

        const res = await this.$axios.put(auth.guests + "/" + id, data);
        if (res.status !== 200) continue;

        const i = this.guestList.findIndex((g) => g._id == id);
        if (i >= 0) this.$set(this.guestList, i, res.data);

        const new_vroom = this.virtualRooma(room);
        if (!new_vroom) await this.addVirtualRooma({ room, guests: [id] });
        else if (!new_vroom.guests.includes(id)) {
          new_vroom.guests.push(id);
          await this.addVirtualRooma(new_vroom);
        }

        let old_vroom = this.virtualRooms.find((el) => el.guests.includes(id));
        if (!old_vroom) old_vroom = this.virtualRooma(old_room);
        if (!old_vroom) continue;
        if (old_room == room && old_vroom.guests.includes(id)) continue;
        const j = old_vroom.guests.findIndex((g) => g == id);
        if (j >= 0) {
          old_vroom.guests.splice(j, 1);
          if (old_vroom.guests.length) await this.addVirtualRooma(old_vroom);
          else await this.deleteVroom(old_vroom._id);
        }
      }
      this.isSuccess("Guests.List.error.change");
    } catch (e) {
      this.isError(e);
    } finally {
      this.spinner = false;
    }
  }

  quickDropVRooms(): void {
    if (!this.$isRoot()) return;
    const vrooms_id: Array<string> = [];
    this.virtualRooms.forEach((vr) => vrooms_id.push(vr._id));
    this.dropVRoomCollection(vrooms_id);
  }

  async dropVRoomCollection(vrooms: Array<string>): Promise<void> {
    try {
      const text = this.$i18n.t("virtual-rooms.drop");
      const result = await this.$bvModal.msgBoxConfirm(String(text), {
        title: String(this.$i18n.t("virtual-rooms.buttons.evict.all")),
      });

      if (result === true) {
        this.spinner = true;
        try {
          const uri = auth.virtual_room.many;
          const res = await this.$axios.put(uri, { vrooms });
          if (res.status === 200) {
            this.spinner = false;
            this.$notify({
              group: "global",
              text: String(this.$i18n.t("error.200")),
            });
            this.start();
          }
        } catch (error) {
          this.spinner = false;
          this.onError();
        }
      }
    } catch {
      this.onError();
    }
  }

  openGuestChangerModal(id: string, room: string): void {
    this.change_id = id;
    this.room_id = room;
    this.$nextTick(() => this.$bvModal.show("guest-changer"));
  }

  onError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  }

  clearGuest(id: string): void {
    const i = this.guestList.findIndex((guest) => guest._id == id);
    if (i < 0) {
      this.getGuests();
      return;
    }
    this.guestList.splice(i, 1);
  }

  /**
   *
   * Удаление гостей с изменением vroom
   */
  async deleteGuests(guests: Array<string>): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.tc("Guests.List.buttons.delete", 2)),
        }
      );

      if (result === true) {
        this.spinner = true;
        const uri = auth.guests_many;
        // изменять vrooms
        const rooms: string[] = [];
        guests.forEach((id: string) => {
          const guest = this.guestList.find((g) => g._id == id);
          if (guest && guest.stay_data?.room?.number)
            rooms.push(guest.stay_data?.room?.id);
        });

        try {
          const vroomUpdates: Array<Promise<boolean>> = [];
          rooms.forEach((room) => {
            const vr = this.virtualRooma(room);
            if (vr) {
              guests.forEach((g) => {
                const i = vr.guests.findIndex((id) => id == g);
                if (i >= 0) {
                  vr.guests.splice(i, 1);
                  vroomUpdates.push(this.addVirtualRooma(vr));
                }
              });
            }
          });

          await Promise.all(vroomUpdates);

          const res = await this.$axios.put(uri, guests);
          if (res.status === 200) {
            this.$notify({
              group: "global",
              text: String(this.$i18n.t("error.200")),
            });
            this.start();
          }
        } catch (error) {
          console.error(error);
          this.onError();
        } finally {
          this.spinner = false;
        }
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  deleteGuest(id: string): void {
    const uri = this.restore ? auth.force_guest : auth.guests;
    deleteElement(id, uri)
      .then(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.clearGuest(id);

        const vrooma = this.virtualRooms.find((vr) => vr.guests.includes(id));
        if (!vrooma) return;
        const i = vrooma.guests.findIndex((g) => g == id);
        if (i < 0) return;
        vrooma.guests.splice(i, 1);
        if (vrooma.guests.length) this.addVirtualRooma(vrooma);
        else this.deleteVroom(vrooma._id);
      })
      .catch((e) => {
        console.error(e);
        this.onError();
      });
  }

  async restoreGuest(id: string): Promise<void> {
    if (!this.restore || !id) return;
    try {
      const uri = auth.restore_guest + "/" + id;
      const restore = await this.$axios.put(uri);
      if (restore.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.clearGuest(id);
      }
    } catch (e) {
      console.error(e);
      this.onError();
    }
  }

  async getGuests(): Promise<void> {
    if (!this.guestList.length) this.spinner = true;
    if (this.change_id) return;

    const uri = auth.guests;
    // status=new,active — новые и заселённые гости; архив после выселения
    // (status=checked_out, проживание в travel_history) не показываем.
    // onboard — ручной статус «на борту», на выборку не влияет
    const params = {
      "match[deleted][value]": false,
      "match[status]": "new,active",
    };
    try {
      const res = await this.$axios.get(uri, { params: params });
      if (res.status === 200) {
        this.spinner = false;
        this.guestList = res.data;
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.spinner = false;
    }
  }

  async getRoomLevels(): Promise<void> {
    const uri = auth.room_level;
    const params = { "match[show]": true, "match[deleted][value]": false };
    try {
      const rooms = await this.$axios.get(uri, params);
      if (rooms.status === 200) {
        this.roomLevels = rooms.data;
      }
    } catch (e) {
      console.error(e);
    }
  }

  async getRoomTypes(): Promise<void> {
    const uri = auth.room_type;
    const params = { "match[show]": true, "match[deleted][value]": false };
    try {
      const rooms = await this.$axios.get(uri, params);
      if (rooms.status === 200) {
        this.roomTypes = rooms.data;
      }
    } catch (e) {
      console.error(e);
    }
  }

  async getRoomStatuses(): Promise<void> {
    const uri = auth.room_status;
    const params = { "match[show]": true, "match[deleted][value]": false };
    try {
      const rooms = await this.$axios.get(uri, params);
      if (rooms.status === 200) {
        this.roomStatuses = rooms.data;
      }
    } catch (e) {
      console.error(e);
    }
  }

  async getRooms(): Promise<void> {
    const uri = auth.room;
    const params = { "match[show]": true, "match[deleted][value]": false };
    try {
      const rooms = await this.$axios.get(uri, { params });
      if (rooms.status === 200) {
        this.rooms = rooms.data;
      }
    } catch (e) {
      console.error(e);
    }
  }

  vroomsControl(vrooms: Array<IVirtualRooma>): Array<IVirtualRooma> {
    const vrs: Array<IVirtualRooma> = [];
    vrooms.forEach((vr) => {
      if (!vr.guests.length) this.deleteVroom(vr._id);
      else vrs.push(vr);
    });
    return vrs;
  }

  async getVirtualRooms(): Promise<void> {
    const uri = auth.virtual_rooms;
    const params = { "match[show]": true, "match[deleted][value]": false };
    try {
      const vrooms_res = await this.$axios.get(uri, { params });
      if (vrooms_res.status === 200) {
        this.virtualRooms = this.vroomsControl(vrooms_res.data);
      }
    } catch (e) {
      console.error(e);
    }
  }

  /**
   * @isVRooma sawe vs check
   */
  async changeGuest(
    data: Partial<IGuest>,
    id: string,
    isVRooma: boolean
  ): Promise<void> {
    this.$bvModal.hide("guest-card-modal");
    this.$bvModal.hide("guest-changer");
    this.change_id = "";
    this.room_id = "";
    const guest = this.guestList.find((g) => g._id == id);
    if (!guest) return;
    const old_room =
      guest.stay_data && guest.stay_data.room ? guest.stay_data.room.id : "";
    const new_room =
      data.stay_data && data.stay_data.room ? data.stay_data.room.id : "";

    const uri = auth.guests + "/" + id;
    try {
      const resGuest = await this.$axios.put(uri, data);
      if (resGuest.status === 200) {
        this.isSuccess("Guests.List.error.change");
        const i = this.guestList.findIndex((g) => g._id == id);
        if (i < 0) this.getGuests();
        else this.$set(this.guestList, i, resGuest.data);

        if (!isVRooma) return;

        const new_vroom = this.virtualRooma(new_room);
        if (!new_vroom) this.addVirtualRooma({ room: new_room, guests: [id] });
        else {
          if (new_vroom.guests.includes(id)) return;
          new_vroom.guests.push(id);
          this.addVirtualRooma(new_vroom);
        }

        let old_vroom = this.virtualRooms.find((el) => el.guests.includes(id));
        if (!old_vroom) old_vroom = this.virtualRooma(old_room);

        if (!old_vroom) return;
        if (old_room == new_room && old_vroom.guests.includes(id)) return;
        const j = old_vroom.guests.findIndex((g) => g == id);
        if (j >= 0) {
          old_vroom.guests.splice(j, 1);
          //изменили старую vroom
          this.addVirtualRooma(old_vroom).then(() => {
            old_vroom = this.virtualRooms.find(
              (vr) => vr._id == old_vroom?._id
            );
            if (old_vroom && !old_vroom?.guests.length)
              this.deleteVroom(old_vroom._id);
          });
        }
      }
    } catch (e) {
      this.isError(e);
    }
  }

  async registrateCollection(): Promise<void> {
    if (this.virtualRooms.length) {
      try {
        const result = await this.$bvModal.msgBoxConfirm(
          String(this.$i18n.t("virtual-rooms.buttons.registrate-oll")),
          {
            title: String(this.$i18n.t("virtual-rooms.buttons.is-vrooms")),
          }
        );

        if (result === true) {
          this.registrarionOll(this.newGuests);
        }
      } catch {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.empty400")),
          type: "warn",
        });
      }
    } else this.registrarionOll(this.newGuests);
  }

  async registrarionOll(list: IGuest[]): Promise<void> {
    this.spinner = true;
    const uri = auth.virtual_room.bulk;
    try {
      const data: string[] = [];
      list.forEach((el) => data.push(el._id));
      const res = await this.$axios.post(uri, { guestIds: data });
      if (res.start === 200) {
        this.spinner = false;
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.start();
      }
    } catch (error) {
      console.log(error);
      this.onError();
      this.spinner = false;
    }
  }

  async addNewGuestMany(guests: IGuest[]): Promise<void> {
    this.$bvModal.hide("guest-card-modal");
    this.$bvModal.hide("guest-changer");
    try {
      const resGuest: AxiosResponse<IGuest> = await this.$axios.post(
        auth.guest.many,
        guests
      );
      if (resGuest.status === 200) {
        this.isSuccess("Guests.List.error.add");
        this.start();
      }
    } catch (e) {
      this.isError(e);
    }
  }

  async addNewGuest(data: IGuest, isVRooma: boolean): Promise<void> {
    this.change_id = "";
    this.room_id = "";
    this.$bvModal.hide("guest-card-modal");
    this.$bvModal.hide("guest-changer");
    try {
      const resGuest: AxiosResponse<IGuest> = await this.$axios.post(
        auth.guests,
        data
      );
      if (resGuest.status === 200) {
        this.guestList.push(resGuest.data);
        this.isSuccess("Guests.List.error.add");
        const room =
          resGuest.data.stay_data && resGuest.data.stay_data.room
            ? resGuest.data.stay_data.room.id
            : "";
        if (!room || !isVRooma) return this.isError(room);

        const vrooma = this.virtualRooma(room);
        const guests = vrooma
          ? vrooma.guests.concat([resGuest.data._id])
          : [resGuest.data._id];

        this.addVirtualRooma({ room, guests });
      }
    } catch (e) {
      this.isError(e);
    }
  }

  async addVirtualRooma(data: Partial<IVirtualRooma>): Promise<boolean> {
    const vrooma = this.virtualRooma(data.room);
    const method = vrooma ? "put" : "post";
    const uri = vrooma
      ? `${auth.virtual_rooms}/${vrooma._id}`
      : auth.virtual_rooms;
    return new Promise((res, rej) => {
      this.$axios[method](uri, data)
        .then(async (vroomres: AxiosResponse<IVirtualRooma>) => {
          if (vroomres.status === 200) {
            await this.getVirtualRooms();
            this.isSuccess("virtual-rooms.errors.200");
            res(true);
          }
        })
        .catch(() => {
          rej(false);
        });
    });
  }

  async changeVroomaGuests(guestid: string): Promise<void> {
    let vrooma: IVirtualRooma | undefined;
    for (const vroom of this.virtualRooms) {
      if (vroom.guests.includes(guestid)) vrooma = vroom;
    }
    if (!vrooma) return;
    const i = vrooma.guests.findIndex((id) => id == guestid);
    if (i < 0) return;
    vrooma.guests.splice(i, 1);
    if (vrooma.guests.length) this.addVirtualRooma(vrooma);
    else this.deleteVroom(vrooma._id);
  }

  async deleteVroom(id: string): Promise<void> {
    deleteElement(id, auth.virtual_rooms)
      .then(() => {
        this.isSuccess("virtual-rooms.errors.deleted");
        this.getVirtualRooms();
      })
      .catch((e) => this.isError(e));
  }

  isError(e: unknown): void {
    console.error(e);
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  }

  isSuccess(text: string): void {
    this.check = true;
    setTimeout(() => (this.check = false), this.$second(2));
    this.$notify({
      group: "global",
      text: String(this.$i18n.t(text)),
    });
  }

  virtualRooma(roomid: string | undefined): IVirtualRooma | undefined {
    return this.virtualRooms.find((vr) => vr.room == roomid);
  }

  requestListFromServer(): void {
    console.log("requestListFromServer");
  }

  async getCruiseList(): Promise<void> {
    const uri = cruiseOffers.mainAPI;
    const ship_code = this.$store.getters.getHotelID;
    if (!ship_code) return;
    const params = { ship_code };
    try {
      const res = await this.$axios.get(uri, { params });
      if (res.status === 200) {
        this.cruises = res.data;
      }
    } catch (e) {
      console.log("ON ERROR");
      console.log(e);
    }
  }

  start(): void {
    this.getGuests();
    this.getVirtualRooms();
  }

  mounted(): void {
    this.getRooms();
    this.getRoomLevels();
    this.getRoomTypes();
    this.getRoomStatuses();
    this.start();
    this.getCruiseList();
    this.vroomInterval = setInterval(() => this.start(), this.$second(10));
    const shipCode = this.$cookies.get("hotelCode");
    if (shipCode) this.shipCode = shipCode;

    this.$nextTick(() => {
      const wiev = localStorage.getItem("guest-list-display-type");
      this.wiev = wiev ? wiev : this.wievs[1];
    });
  }

  destroyed(): void {
    clearInterval(this.vroomInterval);
  }
}
